<template>
  <div class="content-block l-container">
    <PageModelModelCharacteristics
      :model-id="props.pageData.model.id"
      :name="props.pageData.model.name"
      :brand="props.pageData.model.brand"
      :category="props.pageData.model.category"
      :spec="props.pageData.specifications"
      :is-tab="true"
      class="content-block characteristics l-description-grid"
      @change-data="(e) => emit('change-data', e)"
    />
    <div v-if="isCurrency" class="l-description-grid">
      <ModelOffers
        :model="props.pageData.model"
        :offer-filters="props.pageData.filters"
        :offers="props.pageData.offers"
        :per-page="10"
        :changed-page="false"
        show-all
        @set-filter="(e) => emit('set-filter', e)"
        @change-data="(e) => emit('change-data', e)"
        @change-model-sort-top3="$emit('change-model-sort-top3')"
        @to-route="(e) => emit('to-route', 'offers')"
      />
    </div>
  </div>
  <div class="content-block l-container">
    <div v-if="props.seoData" id="description-model" class="l-description-grid">
      <PageModelDescriptionModel :seo-data="props.seoData" />
    </div>
    <div v-if="accessories.length > 0" class="l-description-grid">
      <ModelSimilar
        :similar="accessories"
        title="Аксессуары"
        type="accessories"
        :show-more-button="false"
        :page-data="props.pageData"
        :model-id="props.pageData.model.id"
        :changed-page="props.pageData.changedPage"
        full-width-mobile
        @change-data="(e) => emit('change-data', e)"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
const emit = defineEmits([
  'change-data',
  'change-model-sort-top3',
  'to-route',
  'set-filter',
]);
const accessories = computed(() => props.pageData?.accessories || []);
const props = defineProps({
  pageData: {
    type: Object as () => any,
    required: true,
  },
  seoData: {
    type: Object as () => any,
    required: true,
  },
  isCurrency: {
    type: Boolean,
    default: false,
  },
});
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 16px;
  @include md-block {
    margin-bottom: 24px;
  }
}
</style>
